import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.nutrient',
    modules: [
        R,
    ],
})
@Service('NutrientStore')
export default class NutrientStore extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('nutrients');
    }

}



// WEBPACK FOOTER //
// ./src/app/stores/nutrient.js